export const SPEND_GOALS_CONFIRMED_PREFIX = '[spend-goals-confirmed]';

export interface SpendGoalsConfirmedPayload {
    monthlySpendCents: number;
    monthlyGoalsSpendCents: number;
}

export const buildSpendGoalsConfirmedMessage = ({
    monthlySpendCents,
    monthlyGoalsSpendCents,
}: SpendGoalsConfirmedPayload): string =>
    `${SPEND_GOALS_CONFIRMED_PREFIX} ${JSON.stringify({
        monthlySpendCents,
        monthlyGoalsSpendCents,
    })}`;

export const parseSpendGoalsConfirmedMessage = (
    text: string,
): SpendGoalsConfirmedPayload | null => {
    const trimmed = text.trim();
    if (!trimmed.startsWith(SPEND_GOALS_CONFIRMED_PREFIX)) {
        return null;
    }

    const jsonPayload = trimmed
        .slice(SPEND_GOALS_CONFIRMED_PREFIX.length)
        .trim();

    try {
        const parsed: unknown = JSON.parse(jsonPayload);
        if (
            typeof parsed !== 'object' ||
            parsed == null ||
            typeof (parsed as SpendGoalsConfirmedPayload).monthlySpendCents !==
                'number' ||
            typeof (parsed as SpendGoalsConfirmedPayload)
                .monthlyGoalsSpendCents !== 'number'
        ) {
            return null;
        }

        return parsed as SpendGoalsConfirmedPayload;
    } catch {
        return null;
    }
};
